export enum CaseMode {
  Cooling = 'Cooling',
  Warming = 'Warming',
  Normothermia = 'Normothermia',
  Unknown = 'Unknown'
}